module.exports = __webpack_public_path__ + "img/product-index-icon.66533af3.png";